module.exports = __webpack_public_path__ + "assets/images/8gm.jpg";